var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconQrImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#595959",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#F2F2F2",
    x: 3.5,
    y: 4.5,
    width: 27,
    height: 21,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    x: 1.5,
    y: 6.5,
    width: 27,
    height: 21,
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 6)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 21,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.223 6.796 7.859 8.94 6.128-4.085 5.29 5.628V20c0 .414-.168.79-.44 1.06-.27.272-.646.44-1.06.44H2c-.414 0-.79-.168-1.06-.44A1.495 1.495 0 0 1 .5 20v-2.754l7.723-10.45z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F2F2F2",
    cx: 21,
    cy: 5,
    r: 2.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQrImage);
export default __webpack_public_path__ + "static/media/icon-qr-image.497d276664bcf15962592850b30b3535.svg";
export { ForwardRef as ReactComponent };